import { render, staticRenderFns } from "./afterOrderList.vue?vue&type=template&id=398a85aa&scoped=true"
import script from "./afterOrderList.vue?vue&type=script&lang=js"
export * from "./afterOrderList.vue?vue&type=script&lang=js"
import style0 from "./afterOrderList.vue?vue&type=style&index=0&id=398a85aa&scoped=true&lang=scss"
import style1 from "./afterOrderList.vue?vue&type=style&index=1&id=398a85aa&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398a85aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398a85aa')) {
      api.createRecord('398a85aa', component.options)
    } else {
      api.reload('398a85aa', component.options)
    }
    module.hot.accept("./afterOrderList.vue?vue&type=template&id=398a85aa&scoped=true", function () {
      api.rerender('398a85aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/afterOrderList/afterOrderList.vue"
export default component.exports